import {
  LookingForSomethingElse,
  publishEvent,
  SectionHeader
} from '@uma/react-commons/dist/index';
import React, { useEffect } from 'react';
import ActiveSessions from 'src/components/ActiveSessions';
import AdvancedSecurityOptions from 'src/components/AdvancedSecurityOptions';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import LoginDetails from 'src/components/LoginDetails';
import { FeatureFlagProps } from 'src/App';
import { SecurityScreenDisplayed } from './analytics';
import { Content, Header } from './styles';
import { screenName, screenPath } from 'src/utils/analytics';

const Security = (featureFlagProps: FeatureFlagProps) => {
  const { translate } = useDependencyManagerContext();

  const { originalFeedbackExperience: isOriginalFeedbackExperienceEnabled } =
    featureFlagProps;

  useEffect(() => {
    publishEvent(SecurityScreenDisplayed);
  }, []);

  return (
    <>
      <Header data-testid="security-header">
        <SectionHeader
          title={translate('menu.security', 'Security')}
          subtitle={translate(
            'security.description',
            'Manage your login details and what devices are used to log in to your HP account'
          )}
        />
      </Header>
      <Content>
        <LoginDetails {...featureFlagProps} />
        <AdvancedSecurityOptions {...featureFlagProps} />
        <ActiveSessions {...featureFlagProps} />
      </Content>
      {isOriginalFeedbackExperienceEnabled && (
        <LookingForSomethingElse
          analytics={{
            screenName: screenName,
            screenPath: screenPath
          }}
        />
      )}
    </>
  );
};

export default Security;
